import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import type { BulkPresignedExperienceShellPhotosResponse } from '@/features/experience-shell/http/experience-shell.http.ts'
import {
	type HttpStorePresignBulkExperienceVettingPhotosOptions,
	httpStorePresignBulkExperienceVettingPhotos
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'

export const useBulkPresignedExperienceVettingPhotos = ({
	urlParams,
	options
}: {
	urlParams: HttpStorePresignBulkExperienceVettingPhotosOptions['urlParams']
	options?: UseMutationOptions<
		BulkPresignedExperienceShellPhotosResponse,
		unknown,
		Omit<
			HttpStorePresignBulkExperienceVettingPhotosOptions['payload'],
			'mutationFn'
		>
	>
}) => {
	return useMutation({
		...options,
		mutationFn: (payload) =>
			httpStorePresignBulkExperienceVettingPhotos({ urlParams, payload }),
		onError: (error) => errorHandler(error)
	})
}
